const CountBadge = ({count, fs=12}) => {
    return (<>
        {count>0
            ? (<span className={`badge bg-light-success d-block d-md-inline mb-1 fs-${fs}`}>+{count}</span>)
            : (<span className={`badge bg-light-danger d-block d-md-inline mb-1 fs-${fs}`}>{count}</span>)}
    </>)
}

export default CountBadge;